<template>
    <section class="AccordionInfo ContentSection ContentSection--hasclippath">
      <h5 v-html="properties.title"></h5>
      <p v-html="properties.subtitle"></p>
      <div>
        <article v-for="accordion in properties.accordions" :key="accordion.title">
            <button @click="openAccordionClick(accordion)">
                {{accordion.title}}
                <img src="@/assets/img/ui/accordion-plus.svg" v-if="!accordion.open">
                <img src="@/assets/img/ui/accordion-close.svg" v-else>
            </button>
             
            <div v-if="accordion.open">
                <div v-html="accordion.text" class="AccordionInfo__text"></div>
                <Link :link="accordion.link[0]" v-if="accordion.link.length > 0" :pageData="pageData"></Link>
            </div>
        </article>
      </div>
    </section>
</template>

<script>
import Link from '../util/Link.vue'; 

export default {
  props: ["properties", "pageData"],
  components: {
    Link
  },
  data() {
    return {
        openAccordion: null,
    };
  },
  methods: {
    openAccordionClick(accordion) {
      // Check if the accordion is already open
      if (this.openAccordion === accordion) {
        // Close the accordion
        this.openAccordion = null;
        accordion.open = false;
      } else {
        // Close any open accordions
        if (this.openAccordion) {
          this.openAccordion.open = false;
        }
        // Open the selected accordion
        this.openAccordion = accordion;
        accordion.open = true;
      }
    },
    getRouteFromID(id) {
        return app.manifest.getRouteFromID(id);
    }
  },
  created() {
    // Set all accordions to be closed by default
    this.properties.accordions.forEach((accordion) => {
      accordion.open = false;
    });
  },
};
</script>


<style lang="scss">
    .AccordionInfo {    
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: left;
        padding-top: 80px;
        padding-bottom: 80px;
        background-color: var(--light-grey);

        h5 {
            margin-bottom: 40px;
        }

        &> p {
            margin-bottom: 60px;
        }

        &>div{
            width: 100%;
            max-width: var(--content-max-width);
            padding: var(--content-padding);
            
            &>article{
                width: 100%;
                border-top: solid 1px #000;
                border-bottom: solid 1px #000;

                &:first-of-type {
                    border-bottom: none;
                }

                &:last-of-type {
                    border-top:  none;
                }

                &:nth-of-type(2) {
                    border-top: solid 1px #000;
                }

                &>div {
                    padding: 10px 0 40px 0;
                }

                &>button {
                    position: relative;
                    font-size: 16px;
                    font-weight: bold;
                    height: 70px;
                    &>img {
                        position: absolute;
                        right: 0;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                }

                a.hyperLink {
                    padding-left: 0;
                    color: var(--secondary-color);
                    margin-bottom: 30px;

                    svg {
                        stroke: var(--secondary-color);
                        fill: var(--secondary-color);
                    }
                }
            }
        } 

        .AccordionInfo__text {
            margin-bottom: 12px;

            * {
                padding: 0;
            }
        }

        button {
            cursor: pointer;
            width: 100%;
        }
    }
</style>